import { render } from "./MobileMidea.vue?vue&type=template&id=68274c50&scoped=true"
import script from "./MobileMidea.vue?vue&type=script&lang=js"
export * from "./MobileMidea.vue?vue&type=script&lang=js"

import "./MobileMidea.vue?vue&type=style&index=0&id=68274c50&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68274c50"]])

export default __exports__